import React, { Fragment } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { NotificationSettings } from '../../../../core/api/models';
import ErrorMessage from '../../../../components/text/ErrorMessage';
import { Multiselect } from 'react-widgets';
import {
  AccountType,
  AppNotificationSettings,
  convertPascalCaseToWords,
  ITemplateKeyItem,
} from '../../../../core';

const UpdateForm: React.FunctionComponent<{
  onSubmit: (data: AppNotificationSettings) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  data?: AppNotificationSettings;
  error?: string;
  event?: ITemplateKeyItem;
}> = (props) => {
  const {
    control,
    handleSubmit,
    errors,
    watch,
  } = useForm<AppNotificationSettings>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
  });

  const renderUserTypes = () => {
    return (
      <div className="col-12">
        <label className="font-sm text-uppercase">
          {' '}
          CC Notification User Types
        </label>
        <div className="row">
          <div className="col-12">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                // rules={{
                //   required: true,
                //   validate: (value) => {
                //     return !!(value.length > 0);
                //   },
                // }}
                name="receiverUserTypes"
                defaultValue={props.data?.receiverUserTypes}
                render={({ onChange, value, name }) => (
                  <Multiselect
                    value={value}
                    data={Object.keys(AccountType).map((key) => {
                      return {
                        label: convertPascalCaseToWords(key === "CallCenterExecutive" ? "BusinessDeveloperExecutive" : key === "Agent" ? "TransactionExecutive" : key),
                        value: key,
                      };
                    })}
                    defaultValue={value}
                    textField={'label'}
                    valueField={'value'}
                    placeholder={'Select User Type'}
                    onChange={(val) => {
                      onChange(val?.map((x) => x.value));
                    }}
                    allowCreate="onFilter"
                    autoFocus={true}
                  />
                )}
              />
              {errors.receiverUserTypes && (
                <ErrorMessage>User Type is required</ErrorMessage>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderEnabled = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <Controller
            control={control}
            name="enabled"
            defaultValue={props.data?.enabled || false}
            render={({ onChange, value, name }) => (
              <Fragment>
                <input
                  type="checkbox"
                  id={name}
                  checked={value}
                  onChange={(e) => onChange(e.target.checked)}
                />
                <label htmlFor={name}>Enabled?</label>
              </Fragment>
            )}
          />
          <ErrorMessage>{errors.enabled?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderNotifySalesPerson = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <Controller
            control={control}
            name="notifySalesPerson"
            defaultValue={props.data?.notifySalesPerson}
            render={({ onChange, value, name }) => (
              <Fragment>
                <input
                  type="checkbox"
                  id={name}
                  checked={value}
                  onChange={(e) => onChange(e.target.checked)}
                />
                <label htmlFor={name}>Notify SalesPerson?</label>
              </Fragment>
            )}
          />
          <ErrorMessage>{errors.notifySalesPerson?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderNotifyCrmAgent = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <Controller
            control={control}
            name="notifyCrmAgent"
            defaultValue={props.data?.notifyCrmAgent}
            render={({ onChange, value, name }) => (
              <Fragment>
                <input
                  type="checkbox"
                  id={name}
                  checked={value}
                  onChange={(e) => onChange(e.target.checked)}
                />
                <label htmlFor={name}>Notify CrmAgent?</label>
              </Fragment>
            )}
          />
          <ErrorMessage>{errors.notifyCrmAgent?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderNotifyCustomer = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <Controller
            control={control}
            name="notifyCustomer"
            defaultValue={props.data?.notifyCustomer}
            render={({ onChange, value, name }) => (
              <Fragment>
                <input
                  type="checkbox"
                  id={name}
                  checked={value}
                  onChange={(e) => onChange(e.target.checked)}
                />
                <label htmlFor={name}>Notify Customer?</label>
              </Fragment>
            )}
          />
          <ErrorMessage>{errors.notifyCustomer?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderWhatsappCustomer = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <Controller
            control={control}
            name="whatsappCustomer"
            defaultValue={props.data?.whatsappCustomer}
            render={({ onChange, value, name }) => (
              <Fragment>
                <input
                  type="checkbox"
                  id={name}
                  checked={value}
                  onChange={(e) => onChange(e.target.checked)}
                />
                <label htmlFor={name}>Send to Customer Whatsapp?</label>
              </Fragment>
            )}
          />
          <ErrorMessage>{errors.whatsappCustomer?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderwhatsAppTemplateInfo = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Whatsapp Template Info</label>
          <Controller
            control={control}
            name="whatsAppTemplateInfo"
            defaultValue={props.data?.whatsAppTemplateInfo}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Whatsapp Template Info"
                name={name}
                value={value}
                onChange={onChange}
                id="whatsAppTemplateInfo"
              />
            )}
          />
          <ErrorMessage>{errors.whatsAppTemplateInfo?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderButton = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
            disabled={props.isSubmitting}
          >
            Update
          </button>
        </div>
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div className="p-4">
        <h4 className="mb-3 font-weight-semibold">
          Update {props.event?.name} App Notification Settings
        </h4>
        <Controller
          control={control}
          rules={{ required: 'Event is Required' }}
          name="event"
          defaultValue={props.event?.key}
          render={() => <></>}
        />
        <div className="row gutter-10">
          {renderEnabled()}
          {props.event?.appNotificationTemplateOptions?.notifySalesPerson &&
            renderNotifySalesPerson()}
          {props.event?.appNotificationTemplateOptions?.notifyCrmAgent &&
            renderNotifyCrmAgent()}
          {props.event?.appNotificationTemplateOptions?.notifyCustomer &&
            renderNotifyCustomer()}
          {props.event?.appNotificationTemplateOptions?.whatsappCustomer &&
            renderWhatsappCustomer()}
          {props.event?.appNotificationTemplateOptions?.whatsAppTemplateInfo &&
            renderwhatsAppTemplateInfo()}
          {renderUserTypes()}
          <ErrorMessage>{props.error}</ErrorMessage>
          {renderButton()}
        </div>
      </div>
    </form>
  );
};

export default UpdateForm;
